import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: 'Welt',
		text: "Das ist nur ein Test"
	}
});

export default app;
